import React, { useState } from "react";
import { Link } from "react-router-dom";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import TutorialPopup from "../../../components/TutorialPopup/TutorialPopup";
import State from "../State";
import ReactJson from "react-json-view";
import { fetchProduct, fetchProductLifecycle } from "../../../network/fetch";

const Step5Form = () => {
  const wait = (ms) =>
    new Promise((resolve) => {
      console.log("=== `waiting ${ms}ms` === Step1Form.js === key: 366434 ===");
      console.dir(`waiting ${ms}ms`, { depth: null, colors: true });
      console.log("=================================");
      setTimeout(resolve, ms);
    });

  const [metadata, setMetadata] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [tutorialStep, setTutorialStep] = useState(0);

  const total_steps = 5; // Nombre total d'étapes
  const current_step = 5; // Étape actuelle

  const handleDownloadMetadata = async () => {
    setIsLoading(true);
    const productId = State.batteryProductData.productId;
    const data = { ...metadata };
    const response = await fetchProduct(productId);
    if (response.success) {
      data.batteryProductData = response.data || {};
    }
    const lifecycleResponse = await fetchProductLifecycle(productId);
    if (lifecycleResponse.success) {
      data.lifecycleData = lifecycleResponse.data || {};
    }
    await wait(3000);
    setMetadata(data);
    setIsLoading(false);
  };

  const handleNextTutorialStep = (e) => {
    e.preventDefault();
    if (tutorialStep < tutorialSteps.length - 1) {
      setTutorialStep(tutorialStep + 1);
    } else {
      setTutorialStep(-1); // Toutes les étapes sont terminées
    }
  };

  const handleCloseTutorial = (e) => {
    e.preventDefault();
    setTutorialStep(-1);
  };

  const [tutorialSteps, setTutorialSteps] = useState([
    {
      content: (
        <>
          <p className="tutorial-title">
            Visualiser les données du passeport numérique
          </p>
          <p>
            Pour accéder aux données encodées et obtenir un récapitulatif
            détaillé des informations de chaque étape du cycle de vie de la
            batterie, cliquez sur le bouton "Ouvrir le document" pour afficher
            l’ensemble des données encodées par chaque acteur.
          </p>
        </>
      ),
      closeLabel: "hidden",
      position: { top: "100px", left: "50%", transform: "translateX(-50%)" },
    },
  ]);

  return (
    <form className="container form-esg-2">
      <div className="form-heading-wrapper">
        <ProgressBar total_steps={total_steps} current_step={current_step} />
      </div>
      {tutorialStep >= 0 && (
        <TutorialPopup
          content={tutorialSteps[tutorialStep].content}
          position={tutorialSteps[tutorialStep].position}
          isVisible={tutorialStep >= 0}
          onNext={
            tutorialSteps[tutorialStep].handleNextTutorialStep ||
            handleNextTutorialStep
          }
          onClose={handleCloseTutorial}
          showArrow={tutorialSteps[tutorialStep].showArrow || false}
          tmpNextLabel={tutorialSteps[tutorialStep].nextLabel}
          tmpCloseLabel={tutorialSteps[tutorialStep].closeLabel}
        />
      )}
      <div className="fiels-main-wrapper">
        <div className="text-desc">
          <p>
            Ce document fournit une synthèse complète et accessible de toutes
            les données collectées et encodées dans le DPP
          </p>
        </div>
        {!isLoading && !metadata && (
          <div className="action-btn">
            <button
              className="btn btn-primary"
              onClick={handleDownloadMetadata}
            >
              Ouvrir le document
            </button>
          </div>
        )}
        {!isLoading && metadata && (
          <div className="action-btn">
            <button
              className="btn btn-primary"
              onClick={() => {
                setMetadata(null);
              }}
            >
              Fermer le document
            </button>
          </div>
        )}
        {isLoading && (
          <div className="spinner-wrapper">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Chargement...</span>
            </div>
          </div>
        )}
        {metadata && (
          <div className="metadata-display">
            <h4>Données des documents:</h4>
            <ReactJson
              src={metadata}
              displayRoot={false} // Pour masquer l'objet racine (facultatif)
              theme="monokai" // Vous pouvez changer ce thème selon vos préférences
              collapsed={false} // Pour s'assurer que le JSON est entièrement déployé
              displayDataTypes={false} // Pour masquer les types de données (facultatif)
              displayObjectSize={false} // Pour masquer la taille de l'objet (facultatif)
              enableClipboard={false} // Pour désactiver le bouton de copie (facultatif)
            />
          </div>
        )}
      </div>
    </form>
  );
};

export default Step5Form;
